module.exports = __webpack_public_path__ + "img/hulu.8edb77c1.jpg";